<template>
  <div class="list">
    <ul>
      <li
        v-for="(item, index) in sessions"
        :key="index"
        class="li-box"
        :class="{
          active:
            item.userId === currentSessionUserId &&
            item.contactId === currentSessionContactId,
        }"
        @click="selectSession(item)"
      >
        <div class="li-left">
          <img
            class="avatar"
            width="30"
            height="30"
            :alt="item.covey_user.realname"
            :src="item.covey_user ? item.covey_user.photo : defaultAvatar"
          />
          <div class="name">{{ item.covey_user.realname }}</div>
        </div>
        <el-badge v-if="item.unreadnum > 0" :value="item.unreadnum" />
        <div v-else class="time">{{ item.contact_time | formatTime }}</div>
      </li>
    </ul>
  </div>
</template>
<script>
// import { actions } from "../store";
import { mapState } from "vuex";
import moment from "moment";
export default {
  computed: {
    ...mapState({
      // 过滤后的会话列表
      // sessions: (state) => {
      //   let result = state.chat.sessions.filter((session) =>
      //     session.covey_user.realname.includes(state.chat.filterKey)
      //   );
      //   return result;
      // },
      sessions: (state) => state.chat.sessions,
      defaultAvatar: (state) => state.app.defaultAvatar,
      // 当前会话index
      currentSessionUserId: (state) => state.chat.currentSessionUserId,
      currentSessionContactId: (state) => state.chat.currentSessionContactId,
    }),
  },
  filters: {
    formatTime(val) {
      if (val && moment(val).isValid()) return moment(val).format("YYYY/MM/DD");
      else return "-";
    },
  },
  methods: {
    async selectSession(item) {
      await this.$store
        .dispatch("selectSession", {
          userId: item.userId,
          contactId: item.contactId,
        })
        .then((res) => {
          this.$router.push({
            path: "/chatmain",
            query: { contactId: item.contactId },
          });
        });
    },
  },
  // vuex: {
  //   actions: actions,
  //   getters: {
  //     // 过滤后的会话列表
  //     sessions: ({ sessions, filterKey }) => {
  //       let result = sessions.filter((session) =>
  //         session.user.name.includes(filterKey)
  //       );
  //       return result;
  //     },
  //     // 当前会话index
  //     currentId: ({ currentSessionId }) => currentSessionId,
  //   },
  // },
};
</script>
<style scoped lang="scss">
.list {
  ul {
    list-style: none;
    margin: 0 !important;
    padding: 0 !important;
  }
  li {
    padding: 0 16px;
    box-sizing: border-box;
    height: 90px;
    // border-bottom: 1px solid #292c33;
    cursor: pointer;
    transition: background-color 0.1s;
    background: #f7f6f6;
    // border-radius: 8px;
    // margin-bottom: 16px;
    // opacity: 0.04;
    border-bottom: 0.1px solid #e4e2e1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:hover {
      background: #e4e2e1;
    }
    &.active {
      background: #e4e2e1;
      // opacity: 0.12;
      // border: 1px solid rgba(32, 16, 2, 0.32);
      .avatar {
        width: 60px !important;
        height: 60px !important;
      }
      .name {
        font-size: 18px !important;
      }
    }
  }
  .li-box {
    display: flex;
    flex-direction: row;
    .li-left {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .name {
    // vertical-align: middle;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .avatar {
    width: 50px;
    height: 50px;
    background: #d8d8d8;
    border-radius: 50%;
  }
  .name {
    // display: inline-block;
    margin-left: 8px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #201002;
    height: 32px;
    line-height: 32px;
  }
  .time {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(32, 16, 2, 0.32);
  }
  .el-badge {
    /deep/.el-badge__content {
      vertical-align: baseline;
      border: none;
    }
  }
}
</style>